import { normalizeError } from 'core/common/errors';
import { OrganicChannelAttributionStrategy } from 'core/common/services';
import { AppThunk } from 'core/common/store';
import { isOrganicChannel } from 'core/common/utils/isOrganicChannel';
import { userUtmTagsUpdated } from './userUtmTagsUpdated';

export const markUtmSourceForIncomingUser =
  (): AppThunk => async (dispatch, getState, services) => {
    const { utmTagsService, loggingService, channelAttributionService } = services;

    const isUtmSourceAlreadyExist = !!utmTagsService.getUtmSource();

    if (isUtmSourceAlreadyExist) return;

    try {
      const referrer = document.referrer;
      const isOrganicUser = isOrganicChannel(referrer);

      if (isOrganicUser) {
        channelAttributionService.setAttributionStrategy(
          new OrganicChannelAttributionStrategy(referrer),
        );
      }

      const utmTags = channelAttributionService.getUtmTags();

      const updatedUtmTags = utmTagsService.updateUtmTags(utmTags);

      dispatch(userUtmTagsUpdated(updatedUtmTags));
    } catch (err) {
      const error = normalizeError(err);

      loggingService.error(error);
    }
  };
